module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/return-policy/return-policy-create/return-policy-create.component.css
// module id = ./src/app/return-policy/return-policy-create/return-policy-create.component.css
// module chunks = main